import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { EuiSpacer, EuiButton } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/MultimediaPerm';
import UpdateBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/PrimaryBoxUpdates';
import ImageTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/imageTable';
import WDRGallery from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/WDRGallery';
import ImageAdvancedTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Image/imageAdvancedTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Multimedia Menü // Bild Einstellungen",
  "path": "/Web_User_Interface/1440p_Serie/Multimedia/Bild/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Hier können Sie die Bildparameter Helligkeit, Sättigung, Kontrast, Exposition und Schärfe einstellen. Sie können das Videobild drehen und spiegeln.",
  "image": "./WebUI_1440p_SearchThumb_Multimedia_Image.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Multimedia_Image.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='Multimedia Menü // Bild Einstellungen' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Hier können Sie die Bildparameter Helligkeit, Sättigung, Kontrast, Exposition und Schärfe einstellen. Sie können das Videobild drehen und spiegeln.' image='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Image.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Image.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Multimedia/Image/' locationFR='/fr/Web_User_Interface/1440p_Series/Multimedia/Image/' crumbLabel="Image Settings" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "multimedia-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#multimedia-men%C3%BC",
        "aria-label": "multimedia menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Multimedia Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "bildeinstellungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#bildeinstellungen",
        "aria-label": "bildeinstellungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bildeinstellungen`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/a957db81fb715f8883386b8932f1bd06/abe2a/1440p_Settings_Multimedia_Image.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.52173913043479%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACaUlEQVQoz22TTWsTYRSF+y+ECgasE8gkTWnRNCYzk5lJy+Q78/G+M0kmn7VV1BbUthGsWEGooKsuunStdScu/HmPZGqpoIvD3T2ce869S/l8nlwuR241T0a5ix4d0n73k8b8K87xJVuH3xJtH12yfXyJM/+Oe/Id+eEXWjRHL22SW11leXmZVCrFkqqqJMpmUVbuYnfHTF6fM3z1ifDgDPH8DLn/kfbeKfXZCbXpG2rj13Qev6cWPqFULLFZKLGW32B9/T5L2WyWaynpNBWthPA7uJ0WQbeB33bwWg6OrWPrRcxyAePhA0ztAa16HbPiYOg2lrmNrlksZTIZrl2u3FNwqhW+vXX5cdri6cij5QrCMGIynTEaTxAyJIp6iFASdCNq1Tq2ZSXQcsm4AiYOVRVFUbBMk0ejiGnfRwQenuchpGQ03WNv5tKVAW4rZtANmEaScd+halfQNZtyuXLjcAFNp9OYpklvECPDHr4fJMCFms0W7XoN0dth6PmMWl1mcYPZ0MA2TUzDQteM/wPjOCYMQ3x/AfOvZhAQBCHRYEJ/uosrJEePRxwMmxi6jlM1MXTjpuWkFEVJgIPBgCiK8H3/yqHvIztt4l4bOX5EPNwnFiFnL15y/mwHTStRNa2rDK8bVv9kuAD2+wOC4GZd1/MI2w0it0on8Gj4fWQ/5s38kC/zXfx6BcOw0TXzX6BlWQyHQ6SUCCGSKQMPsTdHHF0w3Tnmc7PJxWBMv9PB2lyjsJ4jk8mSyah/HbaqJhkWi0W2trYSsG3bWAtZJnZDYAe71BqCSVlnVrEobGxwa/k2d+6kki9ZfMpvhMCWsYFCBAwAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a957db81fb715f8883386b8932f1bd06/e4706/1440p_Settings_Multimedia_Image.avif 230w", "/de/static/a957db81fb715f8883386b8932f1bd06/d1af7/1440p_Settings_Multimedia_Image.avif 460w", "/de/static/a957db81fb715f8883386b8932f1bd06/7f308/1440p_Settings_Multimedia_Image.avif 920w", "/de/static/a957db81fb715f8883386b8932f1bd06/85e95/1440p_Settings_Multimedia_Image.avif 1067w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/a957db81fb715f8883386b8932f1bd06/a0b58/1440p_Settings_Multimedia_Image.webp 230w", "/de/static/a957db81fb715f8883386b8932f1bd06/bc10c/1440p_Settings_Multimedia_Image.webp 460w", "/de/static/a957db81fb715f8883386b8932f1bd06/966d8/1440p_Settings_Multimedia_Image.webp 920w", "/de/static/a957db81fb715f8883386b8932f1bd06/d7218/1440p_Settings_Multimedia_Image.webp 1067w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a957db81fb715f8883386b8932f1bd06/81c8e/1440p_Settings_Multimedia_Image.png 230w", "/de/static/a957db81fb715f8883386b8932f1bd06/08a84/1440p_Settings_Multimedia_Image.png 460w", "/de/static/a957db81fb715f8883386b8932f1bd06/c0255/1440p_Settings_Multimedia_Image.png 920w", "/de/static/a957db81fb715f8883386b8932f1bd06/abe2a/1440p_Settings_Multimedia_Image.png 1067w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/a957db81fb715f8883386b8932f1bd06/c0255/1440p_Settings_Multimedia_Image.png",
              "alt": "Web User Interface - 1440p Series - Multimedia Image",
              "title": "Web User Interface - 1440p Series - Multimedia Image",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ImageTable mdxType="ImageTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h4 {...{
      "id": "die-standardwerte-sind",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#die-standardwerte-sind",
        "aria-label": "die standardwerte sind permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Die Standardwerte sind:`}</h4>
    <ul>
      <li parentName="ul">{`Farbton: 0`}</li>
      <li parentName="ul">{`Bildsättigung: 50`}</li>
      <li parentName="ul">{`Kontrast: 55`}</li>
      <li parentName="ul">{`Bildschärfe: 70`}</li>
      <li parentName="ul">{`Helligkeit: 55`}</li>
      <li parentName="ul">{`Vibrance: 128`}</li>
    </ul>
    <EuiSpacer mdxType="EuiSpacer" />
    <UpdateBox mdxType="UpdateBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "erweiterte-bildeinstellungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#erweiterte-bildeinstellungen",
        "aria-label": "erweiterte bildeinstellungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Erweiterte Bildeinstellungen`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/acbb4146b104019339c709b0d4570c49/aa61c/1440p_Settings_Multimedia_Image_Advanced.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.95652173913044%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACtElEQVQ4y3WRXVMTZxiG+Q+OHogQkprMJAHUKVYCm2x2A9lAdrMf735v1CCo4IDaAo6oTJl6Iu3066j/oMJBj5wetYf4Hzzzp1zOLhOo0/bgnmfeeWeuuZ7nHpmenmZycpLJqSnKxQJy/yXG/juWdn+nvXNEa/stC9tvWdw5YmH7CO3ZMeaLY7zXf1ITT5GlWcqVCpdHL5ObyDFSqVTIUq1SvFpg0V2jv/sr8dc/4D8+xN18g7d1SO/Bd+j3DzDuH6Cv7md/S8E6tVuzzMzMcm36Btevf8lItVplmGKphNKYI3RNXKuLrWvYejubWqtOq1FDnpth/qsb2bvb1ljuBGhtk2ZjgbqkMFIulxlalkpF6s0WPz21eXdg8M2KiW65+EGA63mEUcxg5R5BGGELG9fwSJZWMTsOLbVJXZJPgandEKgoKv0kIol8fM/FcRxs20FEd4njiH4/IY4TbD8mER6Hg5jNFYOljsz8nHxumEJL6cqKQhRFmZFwh0Abz/Pwott4foQfhIhogCd6/PJ6gycPF9AWZaT5xrnhZ8A4JgxDfN/PgGksy8QwbQwRYZo9tHab53vP+fD+L95shTRliVaz/o+WKxWKxSKKqp4aum4WxxE4ts1yT7Csm5g9I7PtdnVevdrj48kJf3z7go4qIdfr5y0PgaqqZnZBECCEyNZNk9qmSWFBlNB1++w92eLDyd8cf7/PI1dFSkv5P6Dve2f3G95QCBdXCDwvQIR3cHo6ga7Rmb+JdHMqY/x7ZUUhSZIMOgSm0zR0hNUjDH2COwPCtU1qtRoXLl5idGycK2M5crncqeGw5c8NzwuxLYtkZYNkfZfb/VUeWTYP7AClUWd8fJwvCgXy+XyW/1w5LcOyrDM72+rhrO3h7PzG4O42P2sdfjQsWpLE6NgYhXyeiYmJDPgJF6LmpIXCWngAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/acbb4146b104019339c709b0d4570c49/e4706/1440p_Settings_Multimedia_Image_Advanced.avif 230w", "/de/static/acbb4146b104019339c709b0d4570c49/d1af7/1440p_Settings_Multimedia_Image_Advanced.avif 460w", "/de/static/acbb4146b104019339c709b0d4570c49/7f308/1440p_Settings_Multimedia_Image_Advanced.avif 920w", "/de/static/acbb4146b104019339c709b0d4570c49/2cb71/1440p_Settings_Multimedia_Image_Advanced.avif 1065w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/acbb4146b104019339c709b0d4570c49/a0b58/1440p_Settings_Multimedia_Image_Advanced.webp 230w", "/de/static/acbb4146b104019339c709b0d4570c49/bc10c/1440p_Settings_Multimedia_Image_Advanced.webp 460w", "/de/static/acbb4146b104019339c709b0d4570c49/966d8/1440p_Settings_Multimedia_Image_Advanced.webp 920w", "/de/static/acbb4146b104019339c709b0d4570c49/fa9eb/1440p_Settings_Multimedia_Image_Advanced.webp 1065w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/acbb4146b104019339c709b0d4570c49/81c8e/1440p_Settings_Multimedia_Image_Advanced.png 230w", "/de/static/acbb4146b104019339c709b0d4570c49/08a84/1440p_Settings_Multimedia_Image_Advanced.png 460w", "/de/static/acbb4146b104019339c709b0d4570c49/c0255/1440p_Settings_Multimedia_Image_Advanced.png 920w", "/de/static/acbb4146b104019339c709b0d4570c49/aa61c/1440p_Settings_Multimedia_Image_Advanced.png 1065w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/acbb4146b104019339c709b0d4570c49/c0255/1440p_Settings_Multimedia_Image_Advanced.png",
              "alt": "Web User Interface - 1440p Series - Multimedia Image",
              "title": "Web User Interface - 1440p Series - Multimedia Image",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <h4 {...{
      "id": "wdr-modus",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#wdr-modus",
        "aria-label": "wdr modus permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`WDR Modus`}</h4>
    <p>{`Nutzen Sie den WDR Modus, die WDR Stärke und die manuellen Gamma Presets um die Belichtung Ihrer Aufnahmen auszugleichen. Verhindern Sie das helle Bildbereiche überblenden oder Details im Schatten verschwinden.`}</p>
    <WDRGallery mdxType="WDRGallery" />
    <h4 {...{
      "id": "manuelle-entrauschung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#manuelle-entrauschung",
        "aria-label": "manuelle entrauschung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Manuelle Entrauschung`}</h4>
    <p>{`Neben dem automatischen Rauschfilter bietet Ihnen die Weboberfläche 15 Voreinstellungen mit denen Sie feste Entrauschungsstufen vorgeben können. Bei hohen Stufen wird das Rauschen aus dem Bild  herausgemittlet. Hierbei können Sie jedoch auch Details im Bild "verlieren". Mit einer zu hohen Stufe wird das Bild wird das Bild mehr und mehr "unscharf" erscheinen.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/c2d13/new-nr-presets.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABx0lEQVQoz01T2a6qQBDkzxTZhh1B1KO45eCuMfqi0UR9M9GPrpPqK+Q+dGa6urq6mBm0KIqQZRmCIAD3jHa7LbnneXBdV3JyuIZhKJxOpyORpqnk5BdFAa3b7WI0GknDeDyG7/vo9Xro9/tCzvMccRxjMBgIjzlX1oixhxjFmGsEVqsVkiQBxR3HkcJ8Pq/dcPp0OsV6vRYeBYhNJhNsNhtxToxDNIIkcqUwxYbDIZbLpTgpy1KmV4IVjzViFKw0aE67XC643+94v994PB5SOJ/Pgr1eL9xuNywWC1yvV6l/Pp+ax9rz+ayx7XYL7XA4YDabybTdbidujsejTKsc0DUx5uTu93vhnU4nyRnsZb0+Q14KrfMTSeAZ8kxI4p4rebxZ7nkk5NEpMfaKw/L3V1zw3CzLgmmaIkoib7rVasEwDJC3/fLIIT4vS3FW9ZKn2a4Lw7bR1HXYtv1PVCk0DQONRkNyCaWgmyYazWaNsVcwXZecL0TLLAtdpRD5PvwggO95yAwDHceRhy3huki/WPAf1jZN5EohcV24nofA96ENlQIjjSLESSKPuOBb5JDvnxNHEQaOI7wkDBF+8R+lUCiFPAgEY+8fvPLA49AyobQAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/e4706/new-nr-presets.avif 230w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/d1af7/new-nr-presets.avif 460w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/7f308/new-nr-presets.avif 920w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/e1c99/new-nr-presets.avif 1380w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/76ea5/new-nr-presets.avif 1840w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/06e74/new-nr-presets.avif 2560w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/a0b58/new-nr-presets.webp 230w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/bc10c/new-nr-presets.webp 460w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/966d8/new-nr-presets.webp 920w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/445df/new-nr-presets.webp 1380w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/78de1/new-nr-presets.webp 1840w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/5a003/new-nr-presets.webp 2560w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/81c8e/new-nr-presets.png 230w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/08a84/new-nr-presets.png 460w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/c0255/new-nr-presets.png 920w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/b1001/new-nr-presets.png 1380w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/161ec/new-nr-presets.png 1840w", "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/c2d13/new-nr-presets.png 2560w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/a4beb21eb2ef707bcc0945121d8ecdbb/c0255/new-nr-presets.png",
              "alt": "Noise Reduction Presets",
              "title": "Noise Reduction Presets",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <ImageAdvancedTable mdxType="ImageAdvancedTable" />
    <h4 {...{
      "id": "die-standardwerte-sind-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#die-standardwerte-sind-1",
        "aria-label": "die standardwerte sind 1 permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Die Standardwerte sind:`}</h4>
    <ul>
      <li parentName="ul">{`WDR: aktiv`}</li>
      <li parentName="ul">{`WDR Stärke: 5`}</li>
      <li parentName="ul">{`Flimmerunterdrückung: 1`}</li>
      <li parentName="ul">{`Zu unterdrückende Frquenz: 50 Hz`}</li>
      <li parentName="ul">{`Auto Entrauschen: aktiv`}</li>
      <li parentName="ul">{`Auto Gamma: aktiv`}</li>
      <li parentName="ul">{`Auto Schwarzwerte: aktiv`}</li>
    </ul>
    <h2 {...{
      "id": "einige-weiteren-voreinstellungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#einige-weiteren-voreinstellungen",
        "aria-label": "einige weiteren voreinstellungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Einige weiteren Voreinstellungen`}</h2>
    <p>{`Die folgenden Voreinstellungen können als Startwerte für eine Feineinstellung verwendet werden:`}</p>
    <h3 {...{
      "id": "tag-einstellungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#tag-einstellungen",
        "aria-label": "tag einstellungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Tag Einstellungen`}</h3>
    <h4 {...{
      "id": "bewölkter-tag--außenbereich--mit-wdr",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#bew%C3%B6lkter-tag--au%C3%9Fenbereich--mit-wdr",
        "aria-label": "bewölkter tag  außenbereich  mit wdr permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bewölkter Tag / Außenbereich / mit WDR`}</h4>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setimageattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hue`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-saturation`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-brightness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`65`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-contrast`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`65`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-sharpness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`75`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-denoiseauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`13`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickermode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickerfreq`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-isomax`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-vib`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`150`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hdr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-obauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-ob`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`20`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setvideoattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-wdrmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span></code></pre></div>
    <h4 {...{
      "id": "bewölkter-tag--außenbereich--ohne-wdr",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#bew%C3%B6lkter-tag--au%C3%9Fenbereich--ohne-wdr",
        "aria-label": "bewölkter tag  außenbereich  ohne wdr permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Bewölkter Tag / Außenbereich / ohne WDR`}</h4>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setimageattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hue`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-saturation`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-brightness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`70`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-contrast`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`60`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-sharpness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`70`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-denoiseauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`13`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickermode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickerfreq`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-isomax`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-vib`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`140`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hdr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-obauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setvideoattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-wdrmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span></code></pre></div>
    <h4 {...{
      "id": "gemischtes-licht--innenbereich--mit-wdr",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#gemischtes-licht--innenbereich--mit-wdr",
        "aria-label": "gemischtes licht  innenbereich  mit wdr permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Gemischtes Licht / Innenbereich / mit WDR`}</h4>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setimageattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hue`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-saturation`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-brightness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`45`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-contrast`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`40`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-sharpness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`75`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-denoiseauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`17`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickermode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickerfreq`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-isomax`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-vib`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`148`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hdr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-obauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-ob`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`20`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setvideoattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-wdrmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span></code></pre></div>
    <h4 {...{
      "id": "gemischtes-licht--innenbereich--ohne-wdr",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#gemischtes-licht--innenbereich--ohne-wdr",
        "aria-label": "gemischtes licht  innenbereich  ohne wdr permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Gemischtes Licht / Innenbereich / ohne WDR`}</h4>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setimageattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hue`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-saturation`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-brightness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`60`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-contrast`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`55`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-sharpness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`70`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-denoiseauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickermode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickerfreq`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-isomax`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-vib`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`138`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hdr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-obauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setvideoattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-wdrmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span></code></pre></div>
    <h3 {...{
      "id": "tag-einstellungen-1",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#tag-einstellungen-1",
        "aria-label": "tag einstellungen 1 permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Tag Einstellungen`}</h3>
    <h4 {...{
      "id": "nachtmodus-ir--innenbereich--ohne-wdr",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#nachtmodus-ir--innenbereich--ohne-wdr",
        "aria-label": "nachtmodus ir  innenbereich  ohne wdr permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Nachtmodus (IR) / Innenbereich / ohne WDR`}</h4>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setimagenightattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hue`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-saturation`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-brightness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-contrast`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-sharpness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`25`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-denoiseauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-denoise`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`13`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickermode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickerfreq`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-isomax`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-vib`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`128`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hdr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-obauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-ob`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`6`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setvideoattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-wdrmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span></code></pre></div>
    <h4 {...{
      "id": "nachtmodus--innenbereich--ohne-wdr",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#nachtmodus--innenbereich--ohne-wdr",
        "aria-label": "nachtmodus  innenbereich  ohne wdr permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Nachtmodus / Innenbereich / ohne WDR`}</h4>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setimagenightattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hue`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-saturation`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-brightness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`80`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-contrast`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`60`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-sharpness`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`60`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-denoiseauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-gmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`18`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickermode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-flickerfreq`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`50`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-isomax`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-vib`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-hdr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-obauto`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span><span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`cmd`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setvideoattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-wdrmode`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span></code></pre></div>
    {
      /*
      #### Nachtmodus (IR) / Innenbereich / mit WDR
      ```bash
      cmd=setimagenightattr&-hue=0&-saturation=50&-brightness=55&-contrast=60&-sharpness=75&-denoiseauto=1&-gauto=0&-gmode=7&-flickermode=1&-flickerfreq=50&-isomax=4&-vib=128&-hdr=5&-obauto=1&cmd=setvideoattr&-wdrmode=1
      ```
      #### Nachtmodus / Innenbereich / mit WDR
      ```bash
      cmd=setimagenightattr&-hue=0&-saturation=0&-brightness=80&-contrast=55&-sharpness=75&-denoiseauto=1&-gauto=0&-gmode=18&-flickermode=0&-flickerfreq=50&-isomax=4&-vib=0&-hdr=5&-obauto=0&-ob=18&cmd=setvideoattr&-wdrmode=1
      ```
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      